import { render, staticRenderFns } from "./AvaliarPedido.vue?vue&type=template&id=53bd3144&scoped=true"
import script from "./AvaliarPedido.vue?vue&type=script&lang=js"
export * from "./AvaliarPedido.vue?vue&type=script&lang=js"
import style0 from "./AvaliarPedido.vue?vue&type=style&index=0&id=53bd3144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd3144",
  null
  
)

export default component.exports